import { AGENT_BUILDER_ROUTE, INVESTIGATION_CHAT_PARAM, INVESTIGATION_ROUTE } from '@/config/constants';
import { resolveNavigationChatSessionId } from './resolve-navigation-chat-session-id';

type QueryValue = string | string[] | undefined;

type BuildChatShareUrlArgs = {
  href: string;
  chatSessionId: string;
  isLive?: boolean;
  pathname: string;
  query: Record<string, QueryValue>;
};

export const buildChatShareUrl = ({ href, chatSessionId, isLive, pathname, query }: BuildChatShareUrlArgs) => {
  const url = new URL(href);
  if (isLive !== undefined) url.searchParams.set('is_live', String(isLive));
  if (pathname === INVESTIGATION_ROUTE || pathname === AGENT_BUILDER_ROUTE) {
    const navigationChatSessionId = resolveNavigationChatSessionId({
      fallbackChatSessionId: chatSessionId,
      pathname,
      query,
    });
    if (navigationChatSessionId) url.searchParams.set(INVESTIGATION_CHAT_PARAM, navigationChatSessionId);
  }
  return url.toString();
};
